import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUsLocale from '@/i18n/lang/en-US'
import zhCnLocale from '@/i18n/lang/zh-CN'


const locale = window.config.localLanguage || 'zh_CN'

Vue.use(VueI18n)

const messages = {
  'zh_CN': zhCnLocale,
  'en_US': enUsLocale,
}

const i18n = {
  locale,
  messages
}

export default i18n